import React from 'react'
import "./TabNavigation.scss"

const TabItem = (props) =>{
    const {selected, className, children} = props
    return (
        <div className={`tabs-item ${className} ${selected ? 'selected' : ''}`}>{children}</div>
    )
}

export default TabItem